export default "__VITE_ASSET__CtdVeqUw__"